module.exports = __webpack_public_path__ + "static/media/dentist.243f6046.svg";